export default {
  // 標籤頁
  fiatCurrencySummary: "法幣匯總",
  virtualCurrencySummary: "虛擬幣匯總",
  transactionDetails: "交易詳情",

  // 下載
  downloadFileName: "數據明細",
};
